import React, { useState, useEffect, useRef, useCallback } from "react";
import { Base } from "zina-dogi-react";
import { Route, Switch, withRouter } from "react-router-dom";
import NeoImporterResults from "./NeoImporterResults";
import { service as neoImporterService } from "../redux";
import { Importer } from "../components";

const PKPLACEHOLDER = "__pk__";

const NeoImporter = (props) => {
    const {
        match,
        location,
        history,
        extraParamsRouter,
        url,
        extraProps,
        customUrls,
        backwardCallback,
    } = props;

    const [loading, setLoading] = useState(false);
    const [baseOp, setBaseOp] = useState({
        className: "neoimporter",
        title: "",
        breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }],
        loading: false
    });
    const [importerData, setImporterData] = useState({
        celery_tasks: null,
        upload_file_url: "",
        detail_file_url: "",
        process_file_url: "",
        results_file_url: "",
        template_file_url: "",
        valid_extensions: [],
        validate_file_url: "",
        contentType: "",
        templateUrl: "",
        extraFields: []
    });
    const [fileUploadedId, setFileUploadedId] = useState(null);
    // const [ready, setReady] = useState(false); // Used in class but not really read from state other than setting it
    const [redirected, setRedirected] = useState(false);

    const extraParamsRef = useRef({});
    const extraParamsRouterKey = JSON.stringify(extraParamsRouter || []);

    const _pad = (num, size) => {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    };

    const setBreadcrumbs = (currentBaseOp) => {
        let breadcrumbs = [{ name: "Home", rel: "/", icon: "home" }];

        if (currentBaseOp.title !== "") {
            const pathname = location.pathname.split("/");

            if (match.params.cpo) {
                let cpoUrl = "/detail/";
                if (customUrls && customUrls.cpo) {
                    cpoUrl = customUrls.cpo;
                }
                breadcrumbs.push({
                    name: `CPO`,
                    rel: {
                        pathname: `${cpoUrl}${match.params.cpo}/`,
                        state: { from: "importer" }
                    }
                });
            }
            if (match.params.oet) {
                let oetUrl = "/tracker/";
                if (customUrls && customUrls.oet) {
                    oetUrl = customUrls.oet;
                }
                breadcrumbs.push({
                    name: `OET #${_pad(match.params.oet, 6)}`,
                    rel: {
                        pathname: `${oetUrl}${match.params.oet}/`,
                        state: { from: "importer" }
                    }
                });
                if (match.params.run) {
                    let runUrl = "/run/";
                    if (customUrls && customUrls.run) {
                        runUrl = customUrls.run;
                    }
                    breadcrumbs.push({
                        name: `Run`,
                        rel: {
                            pathname: `${runUrl}${match.params.oet}/${match.params.run}/`,
                            state: { from: "importer" }
                        }
                    });

                    if (location.state && location.state.source === "web_form") {
                        breadcrumbs.push({
                            name: "SSOT Web Form"
                        });
                    }
                }
            }

            // Add Importer Title
            const titleBreadcrumb = { name: currentBaseOp.title };
            const isValidate = pathname.includes("validate");
            const isResults = pathname.includes("results");

            if (isValidate || isResults) {
                titleBreadcrumb.rel = match.url.endsWith('/') ? match.url : `${match.url}/`;
            }
            breadcrumbs.push(titleBreadcrumb);

            if (isValidate) {
                breadcrumbs.push({
                    name: "Validate"
                });
            } else if (isResults) {
                breadcrumbs.push({
                    name: "Results"
                });
            }
        }
        return {
            ...currentBaseOp,
            breadcrumbs
        };
    };

    useEffect(() => {
        if (extraParamsRouter && extraParamsRouter.length) {
            extraParamsRouter.forEach(elem => {
                if (match.params[elem] !== undefined) {
                    extraParamsRef.current[elem] = match.params[elem];
                }
            });
        }

        setBaseOp(prev => ({ ...prev, loading: true }));
        setLoading(true);

        const fetchData = async () => {
            try {
                const response = await neoImporterService.neoImporterInformation(url);
                if (response) {
                    const ePR = extraParamsRouter || [];
                    const extraFields = response.form_api.ordered_fields
                        .filter(field => !ePR.includes(field) && field !== "uploaded_file")
                        .map(key => {
                            const res = { ...response.form_api.fields[key] };
                            res["key"] = key;
                            return res;
                        });

                    const newBaseOp = {
                        ...baseOp,
                        title: response.title,
                        loading: false
                    };

                    setBaseOp(newBaseOp); // Note: this might need adjustment to include breadcrumbs immediately
                    setImporterData({
                        celery_tasks: response.celery_tasks,
                        upload_file_url: response.upload_file_url,
                        detail_file_url: response.detail_file_url,
                        process_file_url: response.process_file_url,
                        results_file_url: response.results_file_url,
                        template_file_url: response.template_file_url,
                        valid_extensions: response.valid_extensions,
                        validate_file_url: response.validate_file_url,
                        contentType: response.importer_type,
                        templateUrl: response.template_file_url,
                        extraFields
                    });
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error fetching importer info", error);
                setBaseOp(prev => ({ ...prev, loading: false }));
                setLoading(false);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, extraParamsRouterKey]); // Only fetch when url or params config changes

    // Update breadcrumbs when location changes or title changes
    const calculatedBaseOp = setBreadcrumbs(baseOp);

    // Override loading state in baseOp if needed
    calculatedBaseOp.loading = loading || baseOp.loading;

    const _uploadSucessfull = output => {
        setFileUploadedId(output.id);
        // setReady(true);
        setBaseOp(prev => ({ ...prev, loading: false }));
        setRedirected(false);
    };

    const handleFinished = useCallback(() => {
        return neoImporterService
            .validateFileUploaded(
                importerData.validate_file_url.replace(
                    PKPLACEHOLDER,
                    fileUploadedId
                )
            )
            .then(results => {
                const baseUrl = match.url.endsWith("/") ? match.url.slice(0, -1) : match.url;
                const redirectUrl = `${baseUrl}/validate/${fileUploadedId}/`;
                if (location.pathname !== redirectUrl) {
                    history.push(redirectUrl);
                }
                setRedirected(true);
                return results;
            })
            .catch(error => {
                console.log({ error });
                return error;
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [importerData.validate_file_url, fileUploadedId, match.url, location.pathname]);

    return (
        <React.Fragment>
            <Base {...calculatedBaseOp} extraProps={extraProps}>
                <Switch>
                    <Route
                        exact
                        path={`${match.url}/validate/:id/`}
                        render={() => (
                            <NeoImporterResults
                                results_file_url={importerData.results_file_url}
                                detail_file_url={importerData.detail_file_url}
                                celery_tasks={importerData.celery_tasks}
                                processUrl={importerData.process_file_url}
                                contentType={importerData.contentType}
                                pk_placeholder="__pk__"
                                validate
                                backwardCallback={async (url, data) => {
                                    if (backwardCallback) {
                                        await backwardCallback(url, data);
                                    } else if (url) {
                                        props.history.push(url, { backward_data: data });
                                    } else {
                                        console.error(
                                            "[NeoImporter] backwardCallback: the server returned enable_backward=true " +
                                            "but no backward_url was provided and no backwardCallback prop was passed. " +
                                            "Pass a backwardCallback prop to <NeoImporter> to handle this action."
                                        );
                                    }
                                }}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={`${match.url}/results/:id/`}
                        render={() => (
                            <NeoImporterResults
                                results_file_url={importerData.results_file_url}
                                detail_file_url={importerData.detail_file_url}
                                celery_tasks={importerData.celery_tasks}
                                contentType={importerData.contentType}
                                pk_placeholder="__pk__"
                                results={true}
                            />
                        )}
                    />
                    <Route
                        exact
                        path=""
                        render={() => (
                            <Importer
                                processUrl={importerData.upload_file_url}
                                validateUrl={importerData.validate_file_url}
                                uploadSucessfull={_uploadSucessfull}
                                fileId={fileUploadedId}
                                template_file={importerData.templateUrl}
                                contentType={importerData.contentType}
                                extraFields={importerData.extraFields}
                                redirected={redirected}
                                finished={handleFinished}
                                extraParams={extraParamsRef.current}
                            />
                        )}
                    />
                </Switch>
            </Base>
        </React.Fragment>
    );
};

export default withRouter(NeoImporter);
